import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { EPAHoldingQueueDetails } from "../../Apis/AuthApiServices";
import {
  loadingEPAHoldingQueueDetails,
  setEPAHoldingQueueDetails,
} from "../Slice/EPAHoldingQueueDetailsSlice";

function* onLoadEPAHoldingQueueDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);

  params.append("prescriptionType", payload.prescriptionType);
  try {
    const result: AxiosResponse = yield EPAHoldingQueueDetails(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setEPAHoldingQueueDetails({
          EPAHoldingQueueDetailsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setEPAHoldingQueueDetails({
          EPAHoldingQueueDetailsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setEPAHoldingQueueDetails({
        EPAHoldingQueueDetailsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadEPAHoldingQueueDetails() {
  yield takeLatest(
    loadingEPAHoldingQueueDetails.type,
    onLoadEPAHoldingQueueDetailsAsync
  );
}

const EPAHoldingQueueDetailsSaga = [fork(onLoadEPAHoldingQueueDetails)];
export default EPAHoldingQueueDetailsSaga;
